import sitAnImg from '../../assets/img/our-approach/situation-analysis.png'

const SituationAnalysis = () => {
  return (
      <section className="bg-[#F0FFF8]">
          <div className="mx-auto w-[90%] max-w-[1440px] py-16 space-y-4">
              <h2 className='md:text-5xl/[69px] text-3xl/10 font-bold'>Situation Analysis</h2>
              <p className='text-2xl/10'>Demographic Composition</p>
              <p>The Washington-Arlington-Alexandria, DC-VA-MD-WV metropolitan area is home to approximately 6.3 million people (2021). Within this region, the demographic breakdown is as follows:</p>
              <ul className='text-xl/8 font-medium list-disc list-inside text-[#034021]'>
                  <li>White: 3,316,519 (52.8%)</li>
                  <li>Black or African American: 1,597,762 (25.4%)</li>
                  <li>Asian: 651,050 (10.4%)</li>
                  <li>Hispanic or Latino: 1,021,386 (16.3%)</li>
              </ul>
              <p className='text-base/6 text-[#034021]'>These figures, sourced from U.S. Census Bureau data and local surveys, including Maryland Department Of Planning, provide the necessary context for our service delivery.</p>
              <img src={sitAnImg} alt='Situation Analysis' className=' w-full rounded-[30px]' />
          </div>
    </section>
  )
}
export default SituationAnalysis